import React, { useState } from 'react';
import { useVoice } from '../hooks/useVoice';
import { useHaptic } from '../hooks/useHaptic';

export const BookCover: React.FC<{ onOpen: () => void }> = React.memo(
  function BookCover({ onOpen }) {
    const [pressed, setPressed] = useState(false);
    const { speak } = useVoice();
    const { trigger } = useHaptic();

    const handleOpen = () => {
      trigger('heavy');
      speak('The Book of RēM opens. I am listening.');
      setPressed(true);
      setTimeout(onOpen, 600);
    };

    return (
      <div className="book-cover" role="region" aria-label="Book cover">
        <div className="book-cover-inner">
          <div className={`book-cover-orb ${pressed ? 'book-open' : ''}`} aria-hidden="true" />
          <h1 className="book-cover-title">Book of RēM</h1>
          <p className="book-cover-subtitle">A sacred companion for the threshold</p>
          <button
            className="book-cover-open-btn"
            onClick={handleOpen}
            aria-label="Open the book"
          >
            Open
          </button>
        </div>
      </div>
    );
  }
);

export default BookCover;
